import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnarchive = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M21.417 7.69997C22.182 7.51283 22.75 6.82252 22.75 6V4C22.75 3.03379 21.9662 2.25 21 2.25H3C2.03379 2.25 1.25 3.03379 1.25 4V6C1.25 6.82252 1.818 7.51284 2.58301 7.69997V19C2.58301 20.5192 3.81379 21.75 5.33301 21.75H18.667C20.1862 21.75 21.417 20.5192 21.417 19V7.69997ZM3 3.75C2.86221 3.75 2.75 3.86221 2.75 4V6C2.75 6.13779 2.86221 6.25 3 6.25H21C21.1378 6.25 21.25 6.13779 21.25 6V4C21.25 3.86221 21.1378 3.75 21 3.75H3ZM19.917 7.75H4.08301V19C4.08301 19.6908 4.64222 20.25 5.33301 20.25H18.667C19.3578 20.25 19.917 19.6908 19.917 19V7.75Z",
		fill: "#111827"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.4697 11.4697C11.7626 11.1768 12.2374 11.1768 12.5303 11.4697L14.5303 13.4697C14.8232 13.7626 14.8232 14.2374 14.5303 14.5303C14.2374 14.8232 13.7626 14.8232 13.4697 14.5303L12.75 13.8107V16.3491C12.75 16.7633 12.4142 17.0991 12 17.0991C11.5858 17.0991 11.25 16.7633 11.25 16.3491V13.8107L10.5303 14.5303C10.2374 14.8232 9.76256 14.8232 9.46967 14.5303C9.17678 14.2374 9.17678 13.7626 9.46967 13.4697L11.4697 11.4697Z",
		fill: "#111827"
	})]
});
const ForwardRef = forwardRef(SvgUnarchive);
export default ForwardRef;
